/** @format */

import { Injectable, inject } from '@angular/core';
import { Environment } from '@shared/data-access/interfaces';

/**
 * @description A centralized service that provides ScoreCard Plus SKU and ecode values
 * from the environment configuration.
 *
 * The `isScoreCardPlusSku(sku)` method is a convenient way to check if a given SKU
 * matches the ScoreCard Plus SKU. This is particularly useful for mapping cart items
 * to a ScoreCard Plus product.
 */
@Injectable({ providedIn: 'root' })
export class ScorecardPlusConfigService {
  private readonly environment = inject(Environment);

  /**
   * Gets the ScoreCard Plus SKU from environment configuration.
   */
  getSku(): string {
    return this.environment.api.scorecardPlus.sku;
  }

  /**
   * Gets the ScoreCard Plus ecode from environment configuration.
   */
  getEcode(): string {
    return this.environment.api.scorecardPlus.ecode;
  }

  /**
   * Checks if the given SKU matches the ScoreCard Plus SKU.
   */
  isScoreCardPlusSku(sku: string): boolean {
    return sku === this.environment.api.scorecardPlus.sku;
  }
}
